import { useEffect, useState } from "react";

/**
 * ライブ波形 (SVG・擬似ランダム棒)。Claude Design の VoiceBar.Waveform を移植。
 * amp 0..1 で高さ、active でアニメーション。音声モード画面で使用。
 */
export function Waveform({ active = true, amp = 1, bars = 20, color = "#3DAEA3", height = 34, width = 92 }: {
  active?: boolean; amp?: number; bars?: number; color?: string; height?: number; width?: number;
}) {
  const [t, setT] = useState(0);
  useEffect(() => {
    if (!active) return;
    let raf = 0;
    const start = performance.now();
    const loop = (now: number) => { setT((now - start) / 1000); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [active]);
  const bw = width / (bars * 1.6);
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: "block" }}>
      {Array.from({ length: bars }).map((_, i) => {
        const phase = (i / bars) * Math.PI * 2;
        const s1 = Math.sin(t * 4 + phase * 1.7);
        const s2 = Math.sin(t * 7 + phase * 0.8 + 1.2);
        const s3 = Math.sin(t * 11 + phase * 2.4);
        const raw = s1 * 0.55 + s2 * 0.3 + s3 * 0.15;
        const env = 0.5 + 0.5 * Math.sin((i / bars) * Math.PI);
        const h = Math.max(2, (0.25 + Math.abs(raw) * 0.75) * env * amp * height);
        const x = i * (width / bars) + (width / bars - bw) / 2;
        const y = (height - h) / 2;
        return <rect key={i} x={x} y={y} width={bw} height={h} rx={bw / 2} fill={color} opacity={active ? 0.92 : 0.3} />;
      })}
    </svg>
  );
}
